var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 5.16699C14.7173 5.16699 15.8256 4.05033 15.8256 2.66699C15.8256 1.28366 14.7173 0.166992 13.334 0.166992C11.9507 0.166992 10.834 1.28366 10.834 2.66699C10.834 4.05033 11.9507 5.16699 13.334 5.16699ZM6.66732 5.16699C8.05065 5.16699 9.15898 4.05033 9.15898 2.66699C9.15898 1.28366 8.05065 0.166992 6.66732 0.166992C5.28398 0.166992 4.16732 1.28366 4.16732 2.66699C4.16732 4.05033 5.28398 5.16699 6.66732 5.16699ZM6.66732 6.83366C4.72565 6.83366 0.833984 7.80866 0.833984 9.75033V11.8337H12.5007V9.75033C12.5007 7.80866 8.60898 6.83366 6.66732 6.83366ZM13.334 6.83366C13.0923 6.83366 12.8173 6.85033 12.5257 6.87533C13.4923 7.57533 14.1673 8.51699 14.1673 9.75033V11.8337H19.1673V9.75033C19.1673 7.80866 15.2757 6.83366 13.334 6.83366Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultNav);
export default __webpack_public_path__ + "static/media/defaultNav.404fe29f754a654c75e6ffb551c42741.svg";
export { ForwardRef as ReactComponent };